import React from 'react';
import PropTypes from 'prop-types';
import { Search, X } from 'lucide-react';
import { cn } from 'src/lib/utils';

/**
 * Shared search box — an inset search icon + a styled text input. Controlled:
 * pass `value` and `onValueChange` (receives the raw string). Set the width on
 * the wrapper via `className` (e.g. `w-52`); the input fills it.
 */
const SearchInput = ({
  value,
  onValueChange,
  placeholder,
  className,
  inputClassName,
  disabled,
}) => (
  <div className={cn('relative w-full', className)}>
    <Search
      className="absolute left-[11px] top-1/2 -translate-y-1/2 w-[15px] h-[15px] text-muted-foreground pointer-events-none"
      strokeWidth={1.8}
    />
    <input
      type="text"
      value={value}
      onChange={(e) => onValueChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      aria-label={placeholder}
      className={cn(
        'w-full pl-[34px] pr-9 py-2 rounded-lg border border-input bg-card text-[12.5px] text-foreground-strong outline-none transition-[border-color,box-shadow] placeholder:text-muted-foreground focus:border-primary focus:ring-[3px] focus:ring-primary/[0.08] disabled:cursor-not-allowed disabled:opacity-50',
        inputClassName
      )}
    />
    {value && !disabled && (
      <button
        type="button"
        onClick={() => onValueChange('')}
        aria-label="Clear search"
        className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center w-[18px] h-[18px] rounded-full bg-muted text-muted-foreground hover:bg-border hover:text-foreground-strong transition-colors"
      >
        <X className="w-[11px] h-[11px]" strokeWidth={2.2} />
      </button>
    )}
  </div>
);

SearchInput.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  disabled: PropTypes.bool,
};

SearchInput.defaultProps = {
  value: '',
  placeholder: 'Search…',
  className: '',
  inputClassName: '',
  disabled: false,
};

export default SearchInput;
